import { render, staticRenderFns } from "./vsListHeader.vue?vue&type=template&id=6e6e6790&lang=html"
import script from "./vsListHeader.vue?vue&type=script&lang=js"
export * from "./vsListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports